import { TendenciaLabel } from "../../ui/Tendencia";
import { calcularDerivadosAtividade } from "../domain";
import type { MomentoPsicomotor } from "../types";
import { ParticipacaoMini } from "./ParticipacaoMini";

/**
 * Indicador compacto de evolução para linhas de lista: mini-escada (passo máximo) +
 * contagem de momentos + tendência. "Bater o olho e ver que está participando mais"
 * — o coração do valor do módulo (P0.4).
 */
export function IndicadorParticipacao({
  atividadeId,
  momentos,
}: {
  atividadeId: string;
  momentos: MomentoPsicomotor[];
}) {
  const d = calcularDerivadosAtividade(atividadeId, momentos);

  if (d.n_momentos === 0) {
    return <div className="evol evol-vazio">ainda sem momentos</div>;
  }

  return (
    <div className="evol">
      <ParticipacaoMini passo={d.passo_maximo} />
      <span className="evol-meta">
        {d.n_momentos} {d.n_momentos === 1 ? "momento" : "momentos"}
      </span>
      {d.tendencia !== "poucos_dados" && <TendenciaLabel tendencia={d.tendencia} />}
    </div>
  );
}
